import { switchMap, filter } from "rxjs/operators";
import {
  ChangeDetectionStrategy,
  Component,
  ChangeDetectorRef,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { UI } from "../../../services/ui.service";
import { GraphicsRepository } from "../../../domain/graphics-repository";
import { GraphicsInfo, GraphicsInfoField } from "../../../domain/graphics-info";
import { UserService } from "../../../domain/user-service";
@Component({
  selector: "icn-edit-graphics",
  templateUrl: "./edit-graphics.component.html",
  styleUrls: ["./edit-graphics.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditGraphicsComponent implements OnInit {
  constructor(
    private _route: ActivatedRoute,
    private _graphicsRepository: GraphicsRepository,
    private _changeDetectionRef: ChangeDetectorRef,
    private ui: UI,
    private router: Router,
    private userService: UserService,
  ) {}

  graphicsInfo: GraphicsInfo = null;

  ngOnInit() {
    this._route.params
      .pipe(
        filter(
          (params: Params) => !!params["graphicId"] || !!params["templateId"],
        ),
        switchMap((params: Params) => {
          if (params["graphicId"]) {
            return this._graphicsRepository.getGraphics(params["graphicId"]);
          } else {
            return this._graphicsRepository.getGraphicsTemplate(
              params["templateId"],
            );
          }
        }),
      )
      .subscribe((graphicsInfo) => {
        this.graphicsInfo = null;
        this._changeDetectionRef.detectChanges();
        this._changeDetectionRef.markForCheck();
        if (!graphicsInfo) {
          return;
        }
        this.graphicsInfo = graphicsInfo;

        this._changeDetectionRef.detectChanges();
        this._changeDetectionRef.markForCheck();
      });
  }

  onFieldValueChange(event: GraphicsInfoField) {
    this._changeDetectionRef.markForCheck();
  }

  onSave() {
    console.log("edit-graphic->onSave", this.graphicsInfo);
    this._graphicsRepository
      .save(this.graphicsInfo)
      .then((response) => {
        console.log(response);

        this.router.navigate(["/scheduler/calendar"]);
      })
      .catch((err) => {
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Server Connectivity!",
          message:
            "It's a shame but something had happen. Please reload the App!",
        });
      });
  }

  onGoLive() {
    this._graphicsRepository.setGoLive(this.graphicsInfo);
  }
}
